import React, { useEffect, useState } from "react";
import { displayMessage, getAPI, postAPI } from "../../utils/common";
import {
  NIGHT_AUDIT_GEN_REPORT,
  NIGHT_AUDIT_PDF,
  NIGHT_AUDIT_REPORT,
} from "../../constants/api";
import { Layout, Card, Button, Table, Space } from "antd";
import LayoutHeader from "../inc/LayoutHeader";
import LayoutFooter from "../inc/LayoutFooter";
import "./ReportsPage.css";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import localizedFormat from "dayjs/plugin/localizedFormat";
import moment from "moment";
import { ERROR_MSG_TYPE, SUCCESS_MSG_TYPE } from "../../constants/messages";

dayjs.extend(utc);
dayjs.extend(localizedFormat);
const NightAudits = () => {
  const { Content } = Layout;
  const [loading, setLoading] = useState(false);
  const [filteredState, setFilteredState] = useState([]);
  const [startDate, setStartDate] = useState(getDefaultDate());

  function getDefaultDate() {
    const now = new Date();
    return now.toISOString().slice(0, 10); // current date in yyyy-mm-dd format
  }
  const fetchReport = () => {
    setLoading(true);
    getAPI(
      NIGHT_AUDIT_REPORT,
      (res) => {
        if (res.status) {
          const formattedData = res["data"].map((row, index) => ({
            key: index,
            ID: index + 1,
            report_date: moment(row.report_date)
              .local()
              .format("MMMM Do, YYYY h:mm A"),
            status: row.status,
            created_at: moment(row.created_at)
              .local()
              .format("MMMM Do, YYYY h:mm A"),

            Action: (
              <Space>
                <Button
                  onClick={() => {
                    const id = row.id;
                    // const encodedId = btoa(id.toString());
                    const url = `${NIGHT_AUDIT_PDF}${id}/pdf`;
                    window.open(url, "_blank");
                  }}
                  block
                >
                  View Report
                </Button>
              </Space>
            ),
          }));

          setFilteredState(formattedData);
        } else {
          displayMessage(ERROR_MSG_TYPE, res.message);
        }
        setLoading(false);
      },
      (err) => {
        console.log(err);
        setLoading(false);
      }
    );
  };

  const genrateReport = () => {
    postAPI(
      NIGHT_AUDIT_GEN_REPORT,
      { date: startDate },
      (res) => {
        if (res.status) {
          fetchReport();
          displayMessage(SUCCESS_MSG_TYPE, res.message);
        } else {
          displayMessage(ERROR_MSG_TYPE, res.message);
        }
      },
      (err) => console.log(err)
    );
  };

  useEffect(() => {
    fetchReport();
  }, []);

  const columns = [
    {
      title: "Sno",
      dataIndex: "ID",
    },
    {
      title: "Report Date",
      dataIndex: "report_date",
    },
    {
      title: "Status",
      dataIndex: "status",
    },
    {
      title: "Genrated On",
      dataIndex: "created_at",
    },
    {
      title: "Action",
      dataIndex: "Action",
    },
  ];
  return (
    <Layout>
      <LayoutHeader />
      <Content>
        <Card
          title="Night Audit"
          extra={
            <>
              <div className="filters">
                <input
                  type="date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                />

                <Button
                  onClick={genrateReport}
                  type="primary"
                  style={{ marginLeft: 10 }}
                >
                  Genrate
                </Button>
                <Button
                  loading={loading}
                  disabled={loading}
                  type="primary"
                  onClick={fetchReport}
                >
                  Refresh
                </Button>
              </div>
            </>
          }
        >
          <Table
            loading={loading}
            columns={columns}
            dataSource={filteredState} // Use filtered state
            pagination={{ pageSize: 10 }}
            scroll={{ x: 240 }}
          />
        </Card>
      </Content>
      <LayoutFooter />
    </Layout>
  );
};

export default NightAudits;
